import { useEffect, useRef } from "react";

const INACTIVITY_MS = 7 * 60 * 1000;
const ACTIVITY_THROTTLE_MS = 1000;
const ACTIVITY_EVENTS = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "wheel", "pointerdown"];

/**
 * Sign out after a stretch of no pointer/keyboard activity while authenticated.
 */
export function useInactivityLogout(enabled, onTimeout) {
  const onTimeoutRef = useRef(onTimeout);
  onTimeoutRef.current = onTimeout;

  useEffect(() => {
    if (!enabled) return undefined;

    let timerId = null;
    let lastReset = 0;

    const arm = () => {
      if (timerId != null) clearTimeout(timerId);
      timerId = window.setTimeout(() => {
        onTimeoutRef.current?.();
      }, INACTIVITY_MS);
    };

    const onActivity = () => {
      const now = Date.now();
      if (now - lastReset < ACTIVITY_THROTTLE_MS) return;
      lastReset = now;
      arm();
    };

    arm();
    for (const eventName of ACTIVITY_EVENTS) {
      window.addEventListener(eventName, onActivity, { capture: true, passive: true });
    }

    return () => {
      if (timerId != null) clearTimeout(timerId);
      for (const eventName of ACTIVITY_EVENTS) {
        window.removeEventListener(eventName, onActivity, { capture: true });
      }
    };
  }, [enabled]);
}
